import React from "react";
import { Input, Modal, InputNumber, Select } from "antd";
import { Form } from "@ant-design/compatible";
import { connect } from "react-redux";
import api from "../../../../../../api";
import strings from "../../../../../../strings";

const FormItem = Form.Item;
const Option = Select.Option;

class AddLoyaltyProgramModal extends React.Component {
  state = {
    loading: false,
    programTypeLabel: strings.spendingTarget,
    programTypeHint: strings.spendingTargetHint1,
  };

  componentDidMount() {
    // Initialize the label with currency when component mounts
    const { user } = this.props;
    const currency = user.currency || (user.employer && user.employer.currency) || "";
    
    this.setState({
      programTypeLabel: `${strings.spendingTarget} (${currency})`,
    });
  }

  handleAddLoyaltyProgram = () => {
    const { form, toggleModal } = this.props;

    form.validateFields((err, values) => {
      if (err) return;

      this.setState({ loading: true });
      api.loyalty
        .addNewLoyaltyProgram(values)
        .then(res => {
          if (res && res.status === 200) {
            form.resetFields();
            Modal.success({
              title: strings.loyaltyProgramAdded,
              content: strings.loyaltyProgramAddedSuccessfully,
              onOk: () => this.props.getAllLoyaltyPrograms(),
            });
            toggleModal();
          }
        })
        .catch(err => {
          console.log('Error creating loyalty program:', err);
          
          let errorMessage = "An error occurred while creating the loyalty program.";
          
          // Try to extract the actual error message from different possible response structures
          if (err.response && err.response.data) {
            if (err.response.data.error) {
              errorMessage = err.response.data.error;
            } else if (err.response.data.message) {
              errorMessage = err.response.data.message;
            } else if (typeof err.response.data === 'string') {
              errorMessage = err.response.data;
            } else if (err.response.data.errors) {
              // Handle validation errors array
              if (Array.isArray(err.response.data.errors)) {
                errorMessage = err.response.data.errors.join(', ');
              } else if (typeof err.response.data.errors === 'object') {
                errorMessage = Object.values(err.response.data.errors).flat().join(', ');
              }
            }
          } else if (err.message) {
            errorMessage = err.message;
          }
          
          Modal.error({
            title: "Error Creating Loyalty Program",
            content: errorMessage
          });
          
          this.setState({ loading: false });
        });
    });
  };

  handleProgramTypeChange = value => {
    const { user } = this.props;
    const currency = user.currency || (user.employer && user.employer.currency) || "";
    
    if (value.toLowerCase() === "simplepoints") {
      this.setState({
        programTypeLabel: `${strings.spendingTarget} (${currency})`,
        programTypeHint: strings.spendingTargetHint1,
      });
    }

    if (value.toLowerCase() === "stampsprogram") {
      this.setState({
        programTypeLabel: strings.stampsTarget,
        programTypeHint: strings.spendingTargetHint2,
      });
    }
  };

  render() {
    const { form, visible, toggleModal } = this.props;
    const { getFieldDecorator } = form;
    const { programTypeLabel, programTypeHint } = this.state;

    return (
      <Modal
        title={strings.addNewLoyaltyProgram}
        okText={strings.addLoyaltyProgram}
        cancelText={strings.cancel}
        onOk={this.handleAddLoyaltyProgram}
        onCancel={() => {
          Modal.confirm({
            title: strings.doYouWantToCloseDialog,
            onOk: toggleModal,
            onCancel: () => {},
          });
        }}
        destoryOnClose
        visible={visible}
        okButtonProps={{ loading: this.state.loading }}
      >
        <Form layout="vertical" >
          <FormItem label={strings.loyaltyProgramType}>
            {getFieldDecorator("program_type", {
              initialValue: "SimplePoints",
              rules: [
                {
                  required: true,
                  message: strings.pleaseSelectLoyaltyProgramType,
                },
              ],
            })(
              <Select
                size="large"
                defaultValue="SimplePoints"
                onChange={this.handleProgramTypeChange}
              >
                <Option value="SimplePoints">SimplePoints</Option>
                <Option value="StampsProgram">StampsProgram</Option>
              </Select>
            )}
          </FormItem>
          <FormItem label={strings.nameOfProgram}>
            {getFieldDecorator("name", {
              rules: [
                {
                  required: true,
                  message: strings.pleaseEnterProgramName,
                },
              ],
            })(<Input size="large" />)}
          </FormItem>
          <FormItem label={programTypeLabel} extra={programTypeHint}>
            {getFieldDecorator("threshold", {
              rules: [
                {
                  required: true,
                  message: strings.pleaseEnterLoyaltyThreshold,
                },
              ],
            })(<InputNumber size="large" style={{ width: "100%" }} />)}
          </FormItem>
          <FormItem
            label={strings.whatIsTheReward}
            extra={strings.egNextPurchaseIsFree}
          >
            {getFieldDecorator("reward", {
              rules: [
                {
                  required: true,
                  message: strings.reward,
                },
              ],
            })(<Input size="large" />)}
          </FormItem>
        </Form>
      </Modal>
    );
  }
}

const AddLoyaltyProgram = Form.create()(AddLoyaltyProgramModal);

const mapStateToProps = state => ({
  user: state.auth.user,
});

export default connect(mapStateToProps)(AddLoyaltyProgram);
